import { sec } from './units.ts';

/**
 * Bruni, the Hollow Forger (artificer; docs/ANTIHEROES.md): a dwarf of Hilde's clan who died at the forge. He shoots
 * from afar with a forge-cannon, makes the structures around him brittle, and his ultimate turns the bastion's own
 * towers on the heroes. Every share of a hero's health goes through armour and shields, as Corvin's (`hurt`).
 */
export const BRUNI = {
  /** His forge-bolt (his basic blow, from `reach` away): at least this share of the struck hero's max health. */
  blowMaxHpBp: 700,
  /** Hollow forge (passive): his blows on structures land this much harder (bp; triple). */
  structureBp: 30000,
  /** ...and the structures within `radius` of him turn brittle (they take more, as a frost colossus's cracks), refreshed every `every`. */
  brittle: { radius: 3500, every: sec(1), ticks: sec(2) },
  /** Riveted bolt: a heavy bolt at the nearest hero in `range` that throws it `knock` back and stuns it. */
  rivet: { every: sec(7), range: 6000, damage: 60, maxHpBp: 1200, knock: 2200, stun: sec(1) },
  /** Black mortar: a marked blast under each hero within `range` (up to `shells`), bursting after `warn`; heroes and towers in it take hard. */
  mortar: { every: sec(13), range: 9000, shells: 3, warn: sec(1.5), radius: 1100, damage: 90, maxHpBp: 2200, towerBp: 1500 },
  /**
   * The forge turned (ultimate): he takes `towers` towers within `range` of him with heroes in their reach (`towersP1`
   * from his second phase), marked with a circle of `mark` while he channels. For `ticks` they shoot the heroes, each
   * shot at least `shotMaxHpBp` of the hero's health. From his last phase, released, each one bursts: heroes within
   * `burst.radius` take hard, and the tower itself loses `burst.towerBp` of its health.
   */
  forge: {
    range: 8000,
    towers: 2,
    towersP1: 3,
    mark: 1000,
    ticks: sec(8),
    shotMaxHpBp: 500,
    burst: { radius: 1600, damage: 120, maxHpBp: 2500, towerBp: 4000 },
  },
};
